import React, { Fragment } from "react";
import Quotes from "../../VibehutUI/Icons/Quotes";
import StarRatingComponent from "react-star-rating-component";
import UserCard from "../../VibehutUI/UserCard";
import { Compliment } from "../../types";
import { getUserData } from "../../services/userService";
import moment from "moment";
import StarIconFilled from "../../VibehutUI/Icons/StarIconFilled";
import StarIcon from "../../VibehutUI/Icons/StarIcon";
import { Menu, Transition } from "@headlessui/react";
import OptionButton from "../../VibehutUI/Icons/OptionButton";

interface Props {
  testimonial: Compliment;
  setTestimonialFeatured?: (id: string, isFeatured: boolean) => void;
  isOwner?: boolean;
}

const TestimonialCard = ({
  testimonial: { _id, rating, description, owner, updatedAt, isFeatured },
  setTestimonialFeatured,
  isOwner,
}: Props) => {
  const ref = React.useRef(null);

  return (
    <div className="h-full relative bg-gray-100 dark:bg-darkGray p-8 rounded-md">
      {isOwner && (
        <>
          <div className="absolute top-0 right-0 m-3">
            <div className="flex gap-0.5 items-center">
              {isFeatured && <p className="mb-2">⭑</p>}
              <div
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                }}
              >
                <Menu as="div" className="relative inline-block text-left">
                  {() => (
                    <>
                      <div>
                        <Menu.Button className="" ref={ref}>
                          <OptionButton />
                        </Menu.Button>
                      </div>
                      <Transition
                        as={Fragment}
                        enter="transition ease-out duration-100"
                        enterFrom="transform opacity-0 scale-95"
                        enterTo="transform opacity-100 scale-100"
                        leave="transition ease-in duration-75"
                        leaveFrom="transform opacity-100 scale-100"
                        leaveTo="transform opacity-0 scale-95"
                      >
                        <Menu.Items className="absolute  w-56 mt-2 origin-center bg-white divide-y divide-gray-100 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-50">
                          <div className="px-1 py-0.5 ">
                            <Menu.Item>
                              <button
                                onClick={() =>
                                  setTestimonialFeatured &&
                                  setTestimonialFeatured(_id, !isFeatured)
                                }
                                className="group flex rounded-md items-center justify-between w-full px-2 py-2 text-sm"
                              >
                                <span className="hover:text-primary">
                                  {isFeatured
                                    ? "Unmark as Featured"
                                    : "Mark as Featured"}
                                </span>
                              </button>
                            </Menu.Item>
                          </div>
                        </Menu.Items>
                      </Transition>
                    </>
                  )}
                </Menu>
              </div>
            </div>
          </div>
        </>
      )}

      <Quotes />
      <div>
        <p className="leading-relaxed mb-2 dark:text-white">{description}</p>
        <StarRatingComponent
          name="rate"
          starCount={5}
          value={rating}
          editing={false}
          renderStarIcon={(index, value) => {
            if (index <= value) {
              return <StarIconFilled width="25" height="22" />;
            }
            return <StarIcon width="25" height="22" />;
          }}
        />
      </div>
      <UserCard
        size="sm"
        user={getUserData(owner)}
        date={moment(updatedAt).format("D MMM YYYY")}
      />
    </div>
  );
};

export default TestimonialCard;
